import React from 'react';
import { Box } from '@chakra-ui/react';
import Head from 'next/head';

const FbShareButton = ({ chatUrl }: { chatUrl: string }) => {
  // TODO: Fix fb share button
  return null;
  return (
    <>
      <Head>
        <script
          async
          defer
          crossOrigin="anonymous"
          src="https://connect.facebook.net/hr_HR/sdk.js#xfbml=1&version=v10.0&appId=1115243928548519&autoLogAppEvents=1"
          nonce="r5NBIVVq"
        />
      </Head>
      <Box justifyContent="center">
        <div id="fb-root" />
        <div
          className="fb-share-button"
          data-href={chatUrl}
          data-layout="button"
          data-size="large"
        >
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://www.facebook.com/sharer/sharer.php?u=${chatUrl}&src=sdkpreparse`}
            className="fb-xfbml-parse-ignore"
          >
            Share
          </a>
        </div>
      </Box>
    </>
  );
};

export default FbShareButton;
